import React, { Component } from "react"
import { Container } from "react-bootstrap"

export default class EtiqaHeader extends Component {
  render() {
    const { logo, claimFormTitle } = this.props

    return (
      <div className="header">
        <Container>
          <div id="top" className="headNav">
            <nav className="js-nav or--active navNew">
              <div className="logo">
                <a href="https://www.etiqa.com.sg" className="link-home">
                  <img src={logo} alt="Etiqa Logo"></img>
                </a>
              </div>
              <div className="navigate d-block">
                <a href="https://www.etiqa.com.sg/">Home</a>
                {" > "}
                <a href="https://www.etiqa.com.sg/claims/submit-claims/">
                  Claims
                </a>
                {" > "}
                <a className="currentNav">{claimFormTitle} Claim</a>
              </div>
            </nav>
          </div>
        </Container>
      </div>
    )
  }
}
